import {localUrlMapping, prodUrlMapping, stagingUrlMapping, qaUrlMapping, uatUrlMapping} from './url-mapping.constant';

function _window(): any {
    return window;
}

export function getInstitutionId(environment = 'local') {
    const hostname = _window().location.hostname;
    let urlMappings: any[];

    switch (environment.toLowerCase()) {
        case 'prod':
            urlMappings = prodUrlMapping;
            break;
        case 'staging':
            urlMappings = stagingUrlMapping;
            break;
        case 'qa':
            urlMappings = qaUrlMapping;
            break;
        case 'uat':
            urlMappings = uatUrlMapping;
            break;
        default:
            urlMappings = localUrlMapping;
            break;
    }

    let institution = urlMappings.find(item => item.url === hostname);

    if (['local', 'uat', 'qa', 'staging'].includes(environment.toLowerCase())) {
        const urlParams = new URLSearchParams(window.location.search);
        const institutionId = urlParams.get('institutionId');
        if (institutionId) {
            // finding institution setup from UAT as it will have all institutions setup in it
            institution.institutionId = institutionId.toUpperCase();
        }
    }
    console.log(institution);
    return institution || urlMappings.find(item => item.institutionId === 'ABC');
}
